<template>
  <div>
    <apexchart
      v-if="model"
      width="800"
      type="bar"
      :options="chartOptions"
      :series="series"
    />
  </div>
</template>

<script>

export default {
  name: 'BarChart',
  props: ['model'],
  data () {
    return {
      chartOptions: {
        chart: { type: 'bar', height: 350 },
        plotOptions: { bar: { horizontal: false, columnWidth: '55%', endingShape: 'rounded' } },
        dataLabels: { enabled: false },
        stroke: { show: true, width: 2, colors: ['transparent'] },
        xaxis: { categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct'] },
        yaxis: { title: { text: '$ (thousands)' } },
        fill: { opacity: 1 },
        tooltip: { y: { formatter: (val) => { return '$ ' + val + ' thousands' } } }
      },
      series: [
        {
          name: 'Net Profit',
          data: []
        }
      ]

    }
  },
  watch: {
    model (data) {
      this.chartOptions.xaxis.categories = data.categorias
      this.series = data.series
    }
  }
}
</script>
